import React from 'react';

export function H3({content, className}) {
    return (
        <h3 className={className}>{content}</h3>
    )
}